import http from "../../http-common";

const loginPost = (data) => {
  return http.post("v1/user/login/", data);
};

export const Auth_Service = {
  loginPost
};